import type { RegionDTO, StateReferenceDTO } from '../types/parameters.types';

const simulateDelay = (ms = 600): Promise<void> =>
	new Promise((resolve) => setTimeout(resolve, ms));

export const MOCK_REGIONS: RegionDTO[] = [
	{
		_id: 'region-1',
		name: 'Região Central',
		stateCodes: ['GO', 'DF', 'TO'],
		stateReferenceId: 'sr-go',
		createdAt: '2023-05-29T00:00:00Z',
		updatedAt: '2023-05-29T00:00:00Z',
	},
	{
		_id: 'region-2',
		name: 'Região Goiás-Minas',
		stateCodes: ['GO', 'MG'],
		stateReferenceId: 'sr-go',
		createdAt: '2023-05-29T00:00:00Z',
		updatedAt: '2023-05-29T00:00:00Z',
	},
	{
		_id: 'region-3',
		name: 'Região Sul de Goiás',
		stateCodes: ['GO'],
		stateReferenceId: 'sr-go',
		createdAt: '2023-05-29T00:00:00Z',
		updatedAt: '2023-05-29T00:00:00Z',
	},
	{
		_id: 'region-4',
		name: 'Região Centro-Leste',
		stateCodes: ['GO', 'MG', 'BA'],
		stateReferenceId: 'sr-go',
		createdAt: '2023-05-29T00:00:00Z',
		updatedAt: '2023-05-29T00:00:00Z',
	},
	{
		_id: 'region-5',
		name: 'Região dos Principais Produtores',
		stateCodes: ['MG', 'SP', 'ES', 'PR', 'BA', 'RO'],
		stateReferenceId: 'sr-mg',
		createdAt: '2023-05-29T00:00:00Z',
		updatedAt: '2023-05-29T00:00:00Z',
	},
];

const MOCK_STATE_REFERENCE_GO: StateReferenceDTO = {
	_id: 'sr-go',
	stateCode: 'GO',
	description: 'Centro Sul de Goiás',
	referenceCode: 'REF-GO-2023',
	dependentParams: [
		{
			code: 'P',
			name: 'Fósforo (P)',
			unit: 'mg/dm³',
			method: 'Mehlich-1',
			rules: [
				{
					criterion: 'texture',
					dependentClasses: [
						{
							texture: 'arenosa',
							idealRange: '4,1 - 8,0',
							fixedClasses: [
								{ classification: 'Baixo', maxValue: 4.0 },
								{ classification: 'Medio', minValue: 4.1, maxValue: 8.0 },
								{ classification: 'Alto', minValue: 8.1, maxValue: 9999 },
							],
						},
						{
							texture: 'media',
							idealRange: '8,1 - 12,0',
							fixedClasses: [
								{ classification: 'Baixo', maxValue: 8.0 },
								{ classification: 'Medio', minValue: 8.1, maxValue: 12.0 },
								{ classification: 'Alto', minValue: 12.1, maxValue: 9999 },
							],
						},
						{
							texture: 'argilosa',
							idealRange: '12,1 - 20,0',
							fixedClasses: [
								{ classification: 'Baixo', maxValue: 12.0 },
								{ classification: 'Medio', minValue: 12.1, maxValue: 20.0 },
								{ classification: 'Alto', minValue: 20.1, maxValue: 9999 },
							],
						},
						{
							texture: 'muitoArgilosa',
							idealRange: '16,1 - 24,0',
							fixedClasses: [
								{ classification: 'Baixo', maxValue: 16.0 },
								{ classification: 'Medio', minValue: 16.1, maxValue: 24.0 },
								{ classification: 'Alto', minValue: 24.1, maxValue: 9999 },
							],
						},
					],
				},
			],
		},
		{
			code: 'K',
			name: 'Potássio (K)',
			unit: 'mg/dm³',
			method: 'Mehlich-1',
			rules: [
				{
					criterion: 'texture',
					dependentClasses: [
						{
							texture: 'arenosa',
							idealRange: '46 - 90',
							fixedClasses: [
								{ classification: 'Baixo', maxValue: 45 },
								{ classification: 'Medio', minValue: 46, maxValue: 90 },
								{ classification: 'Alto', minValue: 91, maxValue: 9999 },
							],
						},
						{
							texture: 'media',
							idealRange: '61 - 120',
							fixedClasses: [
								{ classification: 'Baixo', maxValue: 60 },
								{ classification: 'Medio', minValue: 61, maxValue: 120 },
								{ classification: 'Alto', minValue: 121, maxValue: 9999 },
							],
						},
						{
							texture: 'argilosa',
							idealRange: '76 - 150',
							fixedClasses: [
								{ classification: 'Baixo', maxValue: 75 },
								{ classification: 'Medio', minValue: 76, maxValue: 150 },
								{ classification: 'Alto', minValue: 151, maxValue: 9999 },
							],
						},
						{
							texture: 'muitoArgilosa',
							idealRange: '91 - 180',
							fixedClasses: [
								{ classification: 'Baixo', maxValue: 90 },
								{ classification: 'Medio', minValue: 91, maxValue: 180 },
								{ classification: 'Alto', minValue: 181, maxValue: 9999 },
							],
						},
					],
				},
			],
		},
		{
			code: 'Ca',
			name: 'Cálcio (Ca)',
			unit: 'cmol/dm³',
			method: 'KCl 1 mol/L',
			rules: [
				{
					criterion: 'texture',
					dependentClasses: [
						{
							texture: 'arenosa',
							idealRange: '1,6 - 4,0',
							fixedClasses: [
								{ classification: 'Baixo', maxValue: 1.5 },
								{ classification: 'Medio', minValue: 1.6, maxValue: 4.0 },
								{ classification: 'Alto', minValue: 4.1, maxValue: 9999 },
							],
						},
						{
							texture: 'media',
							idealRange: '2,1 - 5,0',
							fixedClasses: [
								{ classification: 'Baixo', maxValue: 2.0 },
								{ classification: 'Medio', minValue: 2.1, maxValue: 5.0 },
								{ classification: 'Alto', minValue: 5.1, maxValue: 9999 },
							],
						},
						{
							texture: 'argilosa',
							idealRange: '2,6 - 6,0',
							fixedClasses: [
								{ classification: 'Baixo', maxValue: 2.5 },
								{ classification: 'Medio', minValue: 2.6, maxValue: 6.0 },
								{ classification: 'Alto', minValue: 6.1, maxValue: 9999 },
							],
						},
						{
							texture: 'muitoArgilosa',
							idealRange: '3,1 - 7,0',
							fixedClasses: [
								{ classification: 'Baixo', maxValue: 3.0 },
								{ classification: 'Medio', minValue: 3.1, maxValue: 7.0 },
								{ classification: 'Alto', minValue: 7.1, maxValue: 9999 },
							],
						},
					],
				},
			],
		},
		{
			code: 'Mg',
			name: 'Magnésio (Mg)',
			unit: 'cmol/dm³',
			method: 'KCl 1 mol/L',
			rules: [
				{
					criterion: 'texture',
					dependentClasses: [
						{
							texture: 'arenosa',
							idealRange: '0,5 - 1,5',
							fixedClasses: [
								{ classification: 'Baixo', maxValue: 0.4 },
								{ classification: 'Medio', minValue: 0.5, maxValue: 1.5 },
								{ classification: 'Alto', minValue: 1.6, maxValue: 9999 },
							],
						},
						{
							texture: 'media',
							idealRange: '0,8 - 2,0',
							fixedClasses: [
								{ classification: 'Baixo', maxValue: 0.7 },
								{ classification: 'Medio', minValue: 0.8, maxValue: 2.0 },
								{ classification: 'Alto', minValue: 2.1, maxValue: 9999 },
							],
						},
						{
							texture: 'argilosa',
							idealRange: '1,0 - 2,5',
							fixedClasses: [
								{ classification: 'Baixo', maxValue: 0.9 },
								{ classification: 'Medio', minValue: 1.0, maxValue: 2.5 },
								{ classification: 'Alto', minValue: 2.6, maxValue: 9999 },
							],
						},
						{
							texture: 'muitoArgilosa',
							idealRange: '1,2 - 3,0',
							fixedClasses: [
								{ classification: 'Baixo', maxValue: 1.1 },
								{ classification: 'Medio', minValue: 1.2, maxValue: 3.0 },
								{ classification: 'Alto', minValue: 3.1, maxValue: 9999 },
							],
						},
					],
				},
			],
		},
		{
			code: 'S',
			name: 'Enxofre (S)',
			unit: 'mg/dm³',
			method: 'Fosfato Ca monobásico',
			rules: [
				{
					criterion: 'texture',
					dependentClasses: [
						{
							texture: 'arenosa',
							idealRange: '5,1 - 10,0',
							fixedClasses: [
								{ classification: 'Baixo', maxValue: 5.0 },
								{ classification: 'Medio', minValue: 5.1, maxValue: 10.0 },
								{ classification: 'Alto', minValue: 10.1, maxValue: 9999 },
							],
						},
						{
							texture: 'media',
							idealRange: '7,1 - 12,0',
							fixedClasses: [
								{ classification: 'Baixo', maxValue: 7.0 },
								{ classification: 'Medio', minValue: 7.1, maxValue: 12.0 },
								{ classification: 'Alto', minValue: 12.1, maxValue: 9999 },
							],
						},
						{
							texture: 'argilosa',
							idealRange: '9,1 - 15,0',
							fixedClasses: [
								{ classification: 'Baixo', maxValue: 9.0 },
								{ classification: 'Medio', minValue: 9.1, maxValue: 15.0 },
								{ classification: 'Alto', minValue: 15.1, maxValue: 9999 },
							],
						},
						{
							texture: 'muitoArgilosa',
							idealRange: '11,1 - 18,0',
							fixedClasses: [
								{ classification: 'Baixo', maxValue: 11.0 },
								{ classification: 'Medio', minValue: 11.1, maxValue: 18.0 },
								{ classification: 'Alto', minValue: 18.1, maxValue: 9999 },
							],
						},
					],
				},
			],
		},
	],
	fixedParams: [
		{
			code: 'B',
			name: 'Boro (B)',
			unit: 'mg/dm³',
			method: 'Água quente',
			idealRange: '0,35 - 0,9',
			fixedClasses: [
				{ classification: 'Baixo', maxValue: 0.34 },
				{ classification: 'Medio', minValue: 0.35, maxValue: 0.9 },
				{ classification: 'Alto', minValue: 0.91, maxValue: 9999 },
			],
		},
		{
			code: 'Cu',
			name: 'Cobre (Cu)',
			unit: 'mg/dm³',
			method: 'Mehlich-1',
			idealRange: '0,35 - 0,9',
			fixedClasses: [
				{ classification: 'Baixo', maxValue: 0.34 },
				{ classification: 'Medio', minValue: 0.35, maxValue: 0.9 },
				{ classification: 'Alto', minValue: 0.91, maxValue: 9999 },
			],
		},
		{
			code: 'Fe',
			name: 'Ferro (Fe)',
			unit: 'mg/dm³',
			method: 'Mehlich-1',
			idealRange: '0,35 - 0,9',
			fixedClasses: [
				{ classification: 'Baixo', maxValue: 0.34 },
				{ classification: 'Medio', minValue: 0.35, maxValue: 0.9 },
				{ classification: 'Alto', minValue: 0.91, maxValue: 9999 },
			],
		},
		{
			code: 'Mn',
			name: 'Manganês (Mn)',
			unit: 'mg/dm³',
			method: 'Mehlich-1',
			idealRange: '0,35 - 0,9',
			fixedClasses: [
				{ classification: 'Baixo', maxValue: 0.34 },
				{ classification: 'Medio', minValue: 0.35, maxValue: 0.9 },
				{ classification: 'Alto', minValue: 0.91, maxValue: 9999 },
			],
		},
		{
			code: 'Zn',
			name: 'Zinco (Zn)',
			unit: 'mg/dm³',
			method: 'Mehlich-1',
			idealRange: '0,35 - 0,9',
			fixedClasses: [
				{ classification: 'Baixo', maxValue: 0.34 },
				{ classification: 'Medio', minValue: 0.35, maxValue: 0.9 },
				{ classification: 'Alto', minValue: 0.91, maxValue: 9999 },
			],
		},
		{
			code: 'MO',
			name: 'Matéria Orgânica',
			unit: 'dag/dm³',
			method: '---',
			idealRange: '0,35 - 0,9',
			fixedClasses: [
				{ classification: 'Baixo', maxValue: 0.34 },
				{ classification: 'Medio', minValue: 0.35, maxValue: 0.9 },
				{ classification: 'Alto', minValue: 0.91, maxValue: 9999 },
			],
		},
		{
			code: 'H_Al',
			name: 'Acidez Potencial',
			unit: 'cmolc/dm³',
			method: 'Correlação SMP',
			idealRange: '0,35 - 0,9',
			fixedClasses: [
				{ classification: 'Baixo', maxValue: 0.79 },
				{ classification: 'Medio', minValue: 0.35, maxValue: 0.9 },
				{ classification: 'Alto', minValue: 0.91, maxValue: 9999 },
			],
		},
		{
			code: 'SB',
			name: 'Soma de Bases',
			unit: 'cmolc/dm³',
			method: 'Ca+Mg+K+Na',
			idealRange: '0,35 - 0,9',
			fixedClasses: [
				{ classification: 'Baixo', maxValue: 19.9 },
				{ classification: 'Medio', minValue: 0.35, maxValue: 0.9 },
				{ classification: 'Alto', minValue: 0.91, maxValue: 9999 },
			],
		},
		{
			code: 'CTC_ef',
			name: 'CTC Efetiva',
			unit: 'cmolc/dm³',
			method: 'SB+Al',
			idealRange: '0,35 - 0,9',
			fixedClasses: [
				{ classification: 'Baixo', maxValue: 4.9 },
				{ classification: 'Medio', minValue: 0.35, maxValue: 0.9 },
				{ classification: 'Alto', minValue: 0.91, maxValue: 9999 },
			],
		},
		{
			code: 'CTC_pH7',
			name: 'CTC a pH 7,0',
			unit: 'cmolc/dm³',
			method: 'SB+H+Al',
			idealRange: '0,35 - 0,9',
			fixedClasses: [
				{ classification: 'Baixo', maxValue: 0.99 },
				{ classification: 'Medio', minValue: 0.35, maxValue: 0.9 },
				{ classification: 'Alto', minValue: 0.91, maxValue: 9999 },
			],
		},
		{
			code: 'sat_Al',
			name: 'Saturação Alumínio',
			unit: '%',
			method: '(Al/T)*100',
			idealRange: '0,35 - 0,9',
			fixedClasses: [
				{ classification: 'Baixo', maxValue: 0.99 },
				{ classification: 'Medio', minValue: 0.35, maxValue: 0.9 },
				{ classification: 'Alto', minValue: 0.91, maxValue: 9999 },
			],
		},
		{
			code: 'sat_V',
			name: 'Saturação Bases',
			unit: '%',
			method: '(Al/T)*100',
			idealRange: '0,35 - 0,9',
			fixedClasses: [
				{ classification: 'Baixo', maxValue: 0.99 },
				{ classification: 'Medio', minValue: 0.35, maxValue: 0.9 },
				{ classification: 'Alto', minValue: 0.91, maxValue: 9999 },
			],
		},
		{
			code: 'pHagua',
			name: 'PH em H₂O (Acidez Ativa)',
			unit: '',
			method: 'Potenciômetro',
			idealRange: '6,0 - 6,9',
			fixedClasses: [
				{
					classificationPH: { domain: 'Acidez', intensity: 'Elevada' },
					maxValue: 5.0,
				},
				{
					classificationPH: { domain: 'Acidez', intensity: 'Media' },
					minValue: 5.0,
					maxValue: 5.9,
				},
				{
					classificationPH: { domain: 'Acidez', intensity: 'Fraca' },
					minValue: 6.0,
					maxValue: 6.9,
				},
				{
					classificationPH: { domain: 'Neutro', intensity: 'Neutro' },
					minValue: 7.0,
					maxValue: 7.0,
				},
				{
					classificationPH: { domain: 'Alcalinidade', intensity: 'Fraca' },
					minValue: 7.1,
					maxValue: 7.8,
				},
				{
					classificationPH: { domain: 'Alcalinidade', intensity: 'Media' },
					minValue: 7.9,
					maxValue: 8.2,
				},
				{
					classificationPH: { domain: 'Alcalinidade', intensity: 'Elevada' },
					minValue: 8.2,
					maxValue: 9999,
				},
			],
		},
	],
	demandP2O5: [],
	liming: [],
	plastering: [],
	criticalRanges: [],
	drisParams: [],
	createdAt: '2023-05-29T00:00:00Z',
	updatedAt: '2023-05-29T00:00:00Z',
};

export const MOCK_STATE_REFERENCES: Record<string, StateReferenceDTO> = {
	'sr-go': MOCK_STATE_REFERENCE_GO,
	'sr-mg': {
		...MOCK_STATE_REFERENCE_GO,
		_id: 'sr-mg',
		stateCode: 'MG',
		description: 'Minas Gerais',
	},
};

export const fetchRegionsMock = async (): Promise<RegionDTO[]> => {
	await simulateDelay();
	return [...MOCK_REGIONS];
};

export const fetchStateReferenceMock = async (
	stateReferenceId: string
): Promise<StateReferenceDTO> => {
	await simulateDelay(400);
	const ref = MOCK_STATE_REFERENCES[stateReferenceId];
	if (!ref) throw new Error(`StateReference não encontrada: ${stateReferenceId}`);
	return { ...ref };
};

export const updateStateReferenceMock = async (
	id: string,
	data: StateReferenceDTO
): Promise<StateReferenceDTO> => {
	await simulateDelay(500);
	MOCK_STATE_REFERENCES[id] = { ...data };
	return { ...data };
};
